import { select } from "redux-saga/effects";
import { createSelector } from "reselect";
import { ctaLabelSelectorProps } from "@grandvisionhq/configurator";
import { PrescriptionEntrySelectionStepContainer } from "../../../../../../../../steps/PrescriptionEntrySelectionStep/steps/PrescriptionEntrySelectionStep/PrescriptionEntrySelectionStepContainer.js";
import { isBookAppointmentEntrySelection } from "../../../../../../../state/types.js";
import { getPrescriptionType, getRxEntryTypes, getBookAppointmentRoute } from "../../../../../../state/configurator/selectors.js";
const prescriptionEntrySelectionStepBase = {
  *onNext() {
    const prescriptionType = yield select(getPrescriptionType);
    if (!prescriptionType) {
      return new Error(`Prescription type is not defined`);
    }
    if (isBookAppointmentEntrySelection(prescriptionType)) {
      const bookAppointmentRoute = yield select(getBookAppointmentRoute);
      if (!bookAppointmentRoute) {
        return new Error(
          "Cannot redirect to Book Appointment. No book-appointment URL defined in the RxConfigurator"
        );
      }
      window.location.assign(bookAppointmentRoute);
      return new Error("Canceling RxConfigurator flow. User chose to redirect to Book Appointment");
    }
  },
  view: PrescriptionEntrySelectionStepContainer,
  ctaLabel: createSelector(
    ctaLabelSelectorProps,
    getPrescriptionType,
    getRxEntryTypes,
    ({ defaultCtaLabel }, prescriptionType, rxEntryTypes) => {
      const defaultKey = { key: defaultCtaLabel };
      if (!prescriptionType || !rxEntryTypes || rxEntryTypes?.length === 0) {
        return defaultKey;
      }
      const label = rxEntryTypes.find((entry) => prescriptionType === entry.key)?.ctaLabel;
      return label ? { value: label, overrideLastCta: isBookAppointmentEntrySelection(prescriptionType) } : defaultKey;
    }
  )
};
export {
  prescriptionEntrySelectionStepBase
};
//# sourceMappingURL=prescription-entry-selection.js.map
